import React from 'react';
import Pantalla14 from '../Pantalla14/Pantalla14';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';

function PantallaBase14() {

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header
                    imgBack={false}
                    rutaBack='/PantallaBase3'
                    title='Identificación Personal'
                    name='steepTwo' />

                <div className='containerRender'>

                    <Pantalla14 />
                    
                </div>

                <Footer />

            </div>
        </>
    )
}

export default PantallaBase14
